<template>
  <div>
    <b-form-select
      v-model="selected"
      class="mt-4"
      :options="options"
      :name="identifier"
      :class="{ 'bg-danger text-white': isError() }"
      @change="onChangeEvent()"
      @input="onInput()"
    >
      <template v-slot:first>
        <b-form-select-option value="" disabled>{{
          selectMessage
        }}</b-form-select-option>
      </template>
    </b-form-select>
  </div>
</template>

<script>
/**
 * @description
 * @author Philippe Ménard
 * @vue-prop {String} identifier - Identifiant de l'input
 * @vue-prop {String} selectMessage - Le message à afficher dans la première ligne du select
 * @vue-prop {Array} options - Les éléments à mettre dans le select
 * @vue-prop {Boolean} isSubmitted - Si le formulaire a été soumis
 * @vue-prop {String} selectedOption - L'option choisie dans le select
 * @vue-data {String} selected - La valeur sélectionnée
 * @vue-data {Boolean} isValid - Si la sélection est valide
 * @vue-event {String} onInput - Est émis lorsque
 * @vue-event {Object} onChange - Est émis lorsque l'option choisie change
 */
export default {
  name: "InputSelect",
  props: {
    identifier: {
      type: String,
      required: true
    },
    selectMessage: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    isSubmitted: {
      type: Boolean,
      required: true
    },
    selectedOption: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      selected: this.selectedOption ?? "",
      isValid: this.selectedOption != undefined
    };
  },
  methods: {
    /**
     * @description Méthode qui envoie au moment de l'input
     */
    onInput() {
      this.$emit("onInput", this.selected);
    },
    /**
     * @description Les opérations à effectuer lors d'un changement de sélection
     */
    onChangeEvent() {
      this.isValid = true;
      this.$emit("onChange", {
        isValid: this.isValid
      });
    },
    /**
     * @description Vérifie si l'on doit mettre le select en rouge
     * @returns {Boolean} Si le select doit être mis en rouge
     */
    isError() {
      return !this.isValid && this.isSubmitted;
    }
  }
};
</script>
<style scoped>
.custom-select {
  border-radius: 10px !important;
}
</style>
